import { Nullable, PossibleBigNumber } from '@ui/types/utility';
import BigNumber from 'bignumber.js';
import { isNil } from 'lodash-es';
import { useMemo } from 'react';

export const useGetInputAmount = (
  usd: PossibleBigNumber,
  payTokenPrice: Nullable<BigNumber>,
) => {
  return useMemo(() => {
    if (isNil(payTokenPrice) || isNil(usd)) return undefined;

    return usd.div(payTokenPrice);
  }, [usd, payTokenPrice]);
};
